module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_et_estonian-7a473bb4c3d94cc9ca51d0909b2a423d.svg";